import { render } from "./ShippingBillList.vue?vue&type=template&id=4d26afe2&scoped=true"
import script from "./ShippingBillList.vue?vue&type=script&lang=js"
export * from "./ShippingBillList.vue?vue&type=script&lang=js"

import "./ShippingBillList.vue?vue&type=style&index=0&id=4d26afe2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d26afe2"]])

export default __exports__